import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import * as Dati from "../../../Dati";
import { Trad } from "../../../components";
import { _NumberField, _Select } from "../../form";
import { IFideTassiProduct } from "./BondsRatesForm";

const useStyles = makeStyles({
    addIcon: {
        float: "right"
    }
});

interface IBondsRatesDetailsProps {
    Data: IFideTassiProduct[];
    DurationTypes: Dati.TDictTipo;
    OnAddProduct: (product: IFideTassiProduct) => void;
    OnChange: (e: string, val: unknown) => void;
}

export const _BondsRatesDetails: React.FC<IBondsRatesDetailsProps> = ({ Data, DurationTypes, OnAddProduct, OnChange }) => {
    const classes = useStyles();

    const onChangeCommonField = (name: string, val: string) => {
        Data.forEach(product => {
            OnChange(`Dati.${product.Index}.${name}`, val);
        });
    };

    const onChangeBondAmountFrom = (name: string, val: string, index: number) => {
        OnChange(name, val);

        if (index) {
            const previousItem = Data[index - 1];

            OnChange(`Dati.${previousItem.Index}.SommaGarantitaA`, val);
        }
    };

    const onChangeBondAmountTo = (name: string, val: string, index: number) => {
        OnChange(name, val);

        if (index + 1 != Data.length) {
            const nextItem = Data[index + 1];

            OnChange(`Dati.${nextItem.Index}.SommaGarantitaDa`, val);
        }
    };

    return (
        <Grid container spacing={4}>
            <Grid item xs={12} md={11}>
                <Typography variant="h6" color="primary">
                    {Trad.Trad(Data[0].TipoRamo)} - {Trad.Trad(Data[0].TipoProdotto)}
                </Typography>
            </Grid>
            <Grid item xs={12} md={1}>
                <Tooltip title={Trad.Trad("Nuovo")} className={classes.addIcon}>
                    <IconButton aria-label="add" size="small" onClick={() => OnAddProduct(Data[Data.length - 1])}>
                        <AddCircleIcon color="secondary" fontSize="large" />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item container spacing={4}>
                <Grid item xs={12} md={3}>
                    <_Select Value={Data[0].ID_TipoDurata} Name="ID_TipoDurata" Label="Tipo durata" OnChange={onChangeCommonField} Options={DurationTypes} />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField value={Data[0].Durata} id="Durata" label={Trad.Trad("Durata")} onChange={e => onChangeCommonField(e.currentTarget.id, e.currentTarget.value)} fullWidth />
                </Grid>
            </Grid>
            <Grid item container spacing={4}>
                {Data.map((product, index) => (
                    <Grid item container spacing={4} key={product.Index}>
                        <Grid item xs={12} md={3}>
                            <_NumberField
                                ProgressBar
                                Id={`Dati.${product.Index}.SommaGarantitaDa`}
                                Label="Somma garantitaDa"
                                Value={product.SommaGarantitaDa}
                                Max={product.SommaGarantitaA}
                                OnChange={(e, val) => onChangeBondAmountFrom(e, val, index)}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <_NumberField
                                ProgressBar
                                Id={`Dati.${product.Index}.SommaGarantitaA`}
                                Label="Somma garantitaA"
                                Value={product.SommaGarantitaA}
                                Max={product.LimitePerSingoloProdotto}
                                Min={product.SommaGarantitaDa}
                                OnChange={(e, val) => onChangeBondAmountTo(e, val, index)}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <_NumberField Id={`Dati.${product.Index}.PremioFisso`} Label="Premio fisso" Value={product.PremioFisso} OnChange={OnChange} />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <_NumberField ProgressBar Id={`Dati.${product.Index}.TassoMin`} Label="Tasso min" Value={product.TassoMin} Max={10} Min={product.LimiteTassoMinimo} OnChange={OnChange} />
                        </Grid>
                    </Grid>
                ))}
            </Grid>
        </Grid>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/components/BondsRates/BondsRatesDetails.tsx